interface AgentData {
  id: string;
  name: string;
  zone?: string;
  status?: string;
  description?: string;
  tools?: string[];
  connectors?: string[];
}

const STATUS_COLORS: Record<string, string> = {
  active: "bg-green-500",
  paused: "bg-yellow-500",
  retired: "bg-gray-500",
  draft: "bg-blue-500",
  validated: "bg-cyan-500",
  reviewed: "bg-purple-500",
};

const ZONE_COLORS: Record<string, string> = {
  internal: "text-blue-400",
  bridge: "text-yellow-400",
  external: "text-red-400",
  system: "text-purple-400",
};

export function AgentListWidget({ data }: { data: Record<string, unknown> }) {
  const agents = (data.agents ?? []) as AgentData[];

  if (agents.length === 0) {
    return <div className="text-gray-500 text-center py-4">No agents found</div>;
  }

  return (
    <div className="space-y-2">
      {agents.map((agent) => (
        <div
          key={agent.id}
          className="bg-gray-800/50 border border-gray-700/50 rounded px-3 py-2"
        >
          <div className="flex items-center gap-2 mb-1">
            <span
              className={`w-2 h-2 rounded-full ${STATUS_COLORS[agent.status ?? ""] ?? "bg-gray-500"}`}
            />
            <span className="font-medium text-gray-200">{agent.name}</span>
            {agent.zone && (
              <span className={`text-xs ${ZONE_COLORS[agent.zone] ?? "text-gray-400"}`}>
                {agent.zone}
              </span>
            )}
            {agent.status && (
              <span className="text-xs text-gray-500 ml-auto">{agent.status}</span>
            )}
          </div>
          {agent.description && (
            <div className="text-xs text-gray-500 mb-1">{agent.description}</div>
          )}
          {agent.tools && agent.tools.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-1">
              {agent.tools.slice(0, 5).map((t) => (
                <span key={t} className="text-xs bg-gray-700 text-gray-400 px-1.5 py-0.5 rounded">
                  {t}
                </span>
              ))}
              {agent.tools.length > 5 && (
                <span className="text-xs text-gray-500">+{agent.tools.length - 5} more</span>
              )}
            </div>
          )}
        </div>
      ))}
      <div className="text-xs text-gray-600 text-center pt-1">
        {agents.length} agent{agents.length !== 1 ? "s" : ""}
      </div>
    </div>
  );
}
